import React, { createContext, useContext, useRef } from "react";

const HeaderAnchorContext = createContext();

/**
 * Custom hook to access the header anchor ref
 * @returns {Object} The header anchor ref object
 */
export const useHeaderAnchor = () => {
  const context = useContext(HeaderAnchorContext);
  if (!context) {
    throw new Error("useHeaderAnchor must be used within a HeaderAnchorProvider");
  }
  return context;
};

/**
 * Provider component that provides the header anchor ref to child components
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 */
export const HeaderAnchorProvider = ({ children }) => {
  const anchorRef = useRef(null);

  return (
    <HeaderAnchorContext.Provider value={anchorRef}>
      {children}
    </HeaderAnchorContext.Provider>
  );
};

